import * as io from "io-ts";
import { Period } from "../period";
// import { Resources } from "../resource";
import { Transforms } from "diagnostics-domain/dashboard/type";
export const BlockData = io.partial({
  title: io.string,
  period: Period,
  //   resources: Resources,
  transforms: Transforms,
});
